<template>
  <div class="delay-exam">
    <Header title="学生成绩查询" type="0" route="/teacher/scoreEntry" ></Header>
    <NOdata v-if="this.lstCj0704.length == 0" title="暂无学生数据~"></NOdata>

    <div v-else class="xscj">
      <div class="biaotou">
        <p style="width: 10%">序号</p>
        <p style="width: 20%">姓名</p>
        <p style="width: 25%">学号</p>
        <p style="width: 30%">班级</p>
        <p style="width: 15%">总成绩</p>
      </div>

      <div v-for="(item,index) in lstCj0704" :key="index" :class="(index+1)%2==0 ?'biaotou oushu':'biaotou danshu'" @click="handle(index)">
        <p style="width: 10%">{{index+1}}</p>
        <p style="width: 20%">{{item.xm}}</p>
        <p style="width: 25%">{{item.xh}}</p>
        <p style="width: 30%">{{item.bj}}</p>
        <p style="width: 15%">{{getzcj(index)}}</p>
      </div>

    </div>

    <van-popup v-model="popShow" class="popup" v-if="this.lstCj0704.length != 0">
      <div>{{this.lstCj0704[popList].xm}}</div>
      <p>学号：{{this.lstCj0704[popList].xh}}</p>
      <p>班级：{{this.lstCj0704[popList].bj}}</p>
      <p>考试性质：{{this.lstCj0704[popList].ksxz}}</p>
      <p v-for="(item,index) in lstCj0712" :key="index">
        {{item.cjxmmc}}：{{getxmcj(item.cjxmbh,popList)}}
      </p>
      <p v-if="(this.cjfs=='D'||this.cjfs=='E')&&this.sfxsyszcj=='1'">原始总成绩：{{this.lstCj0704[popList].yszcj}}</p>
      <p>总成绩：{{getzcj(popList)}}</p>
      <p>成绩标志：{{this.lstCj0704[popList].cjbs}}</p>
      <p>说明：{{this.lstCj0704[popList].sm}}</p>
      <p>录入人：{{this.lstCj0704[popList].xgr}}</p>
      <p>修改时间：{{this.lstCj0704[popList].xgsj}}</p>
      <button @click="closePop()">确定</button>
    </van-popup>



  </div>
</template>

<script>
  import { Api } from "../../../utils/axios";
  export default{
    data(){
      return{
        applyDetail:[],
          schoolCode: sessionStorage.getItem("schoolCode"),
          cj0703id:"",
          cj0701id:"",
          lstCj0704:[], //学生
          lstCj0712:[],
          lstDjmc:[],
          popShow : false,
          popList:"0",
          cjfs:"",
          sfxsyszcj:""
      }
    },
    created(){
      this.cj0703id =this.$route.query.cj0703id
      this.cj0701id =this.$route.query.cj0701id

      this.getStudent()
    },
     methods:{
         async getStudent() {

             const params = {
                 cj0703id: this.cj0703id,
                 cj0701id:this.cj0701id,
                 type: "student"
             }
             const res = await Api.getCjllcx(params)
             if(res.code=="1"){
                 this.lstCj0704=res.lstCj0704
                 this.lstCj0712=res.lstCj0712
                 this.cjfs=res.cjfs
                 this.sfxsyszcj=res.sfxsyszcj
                 this.lstDjmc=res.lstDjmc
             }
         },
         handle(index){
             this.popShow = true;
             this.popList = index;
         },
         closePop(){
             this.popShow = false;
         },
         getxmcj(cjxmbh,index){
             var bh=parseInt(cjxmbh)
             var item=this.lstCj0704[index]
             var cjxm=item["cjxm"+bh]
             if(this.cjfs!="D" && this.cjfs!="E"){
                 cjxm ="--";//等级成绩不显示项目分数
             }
             return cjxm
         },
         getzcj(index){
             var zcj="";
             if(this.cjfs=='E'){
                 zcj=this.lstCj0704[index].cjxs
             }
             else if(this.cjfs=='D'){
                 zcj=this.lstCj0704[index].zcj
             }
             else{
                 this.lstDjmc.forEach((item,index) => {
                     if (item.dyfs==this.lstCj0704[index].zcj){
                         zcj=item.djfsmc
                     }
                 });
             }
             return zcj
         }
     }
  }
</script>

<style lang="less" scoped>
  .xscj{
    width: 95%;
    margin-left: 2.5%;
    padding: 0px;
    font-size: 12px;
    text-align: center;
  }
  .biaotou{
    display: flex;
    background-color:rgb(134,163,194);
    height: 30px;
    line-height: 30px;
    padding: 0px;
    margin: 0px;

  }
  .oushu{
    background-color:rgb(233,233,233);
  }
  .danshu{
    background-color:rgb(225,223,225);
  }
  .van-popup.van-popup--center{box-sizing: border-box;padding: 20px; }
  .van-popup.van-popup--center>h2{color: @attendance-color-1;font-size: 16px;line-height: 25px;text-align: center;font-weight: bold;}
  .van-popup.van-popup--center>div{color: @attendance-background-color-1;font-size: 24px;font-weight: bold;text-align: center;padding-top: 10px;padding-bottom: 10px;}
  .van-popup.van-popup--center>p{color: @attendance-color-2;font-size: 16px;line-height: 30px;word-wrap:break-word}
  .van-popup.van-popup--center>p>span{
    /*width: 200px;*/

  }
  .van-popup--center{width: 90%;border-radius: 5px;}
  .van-popup.van-popup--bottom{border-radius: 5px 5px 0 0;}
  .popup button{background-color: @attendance-background-color-7;color: @attendance-background-color-1;padding: 11px 0;border-radius: 3px;width: 100%;margin-top: 30px;}

  .confirm{background-color: royalblue}
  .my-apply1{padding: 20px;}
  .apply-ttl{font-size: 24px;font-weight: 700;}
  .apply-sub{font-size: 18px;color: @attendance-color-1;font-weight: 700;margin: 20px 0;}
  .my-apply1 .reason{display: flex;}
  .reason-txt{flex: 1;}
  .my-apply1 .info-text{font-size: 14px;color: @attendance-color-2;line-height: 25px;}
  .delay-btn{position: fixed;padding: 20px;width: 100%;text-align: center;bottom: 0;background-color: @attendance-color-3;box-sizing: border-box;}
  .delay-btn button{background-color: @attendance-background-color-7;color: @attendance-background-color-1;padding: 11px 0;width: 40%;border-radius: 3px;}
</style>



// WEBPACK FOOTER //
// src/components/teacher/scoreEntry/details.vue